<template>
  <a-row :gutter="24">
    <a-col :md="24">
      <a-card :style="cardStyle" :bordered="false">
        <template v-if="!printMode">
          <div class="table-page-search-wrapper">
            <a-form layout="inline" @keyup.enter.native="searchQuery">
              <a-row :gutter="24">
                <a-col :md="6" :sm="24">
                  <a-form-item label="门店" :labelCol="labelCol" :wrapperCol="wrapperCol">
                    <store-tenant-select domain="sale" @change="handleStoreTenantChange"></store-tenant-select>
                  </a-form-item>
                </a-col>
                <a-col :md="6" :sm="24">
                  <a-form-item label="单据日期" :labelCol="labelCol" :wrapperCol="wrapperCol">
                    <a-range-picker
                      style="width: 100%"
                      v-model="queryParam.dateRange"
                      format="YYYY-MM-DD"
                      :placeholder="['开始日期', '结束日期']"
                      @change="onDateChange"
                    />
                  </a-form-item>
                </a-col>
                <a-col :md="6" :sm="24">
                  <a-form-item label="类别" :labelCol="labelCol" :wrapperCol="wrapperCol">
                    <a-tree-select
                      style="width: 100%"
                      :dropdownStyle="{ maxHeight: '200px', overflow: 'auto' }"
                      allow-clear
                      :treeData="categoryTree"
                      v-model="queryParam.categoryId"
                      placeholder="请选择类别">
                    </a-tree-select>
                  </a-form-item>
                </a-col>
                <a-col :md="6" :sm="24" v-if="orgaTree.length">
                  <a-form-item label="机构" :labelCol="labelCol" :wrapperCol="wrapperCol">
                    <a-tree-select style="width:100%" allow-clear :treeData="orgaTree"
                                   v-model="queryParam.organizationId" placeholder="请选择机构">
                    </a-tree-select>
                  </a-form-item>
                </a-col>
                <a-col :md="6" :sm="24">
                  <span class="table-page-search-submitButtons">
                    <a-button type="primary" @click="searchQuery">查询</a-button>
                    <a-button style="margin-left: 8px" @click="searchReset">重置</a-button>
                    <a-button style="margin-left: 8px" icon="printer"
                      v-if="btnEnableList.indexOf('5')>-1"
                      @click="handlePrint">打印</a-button>
                    <a-button style="margin-left: 8px" @click="exportExcel" icon="download" v-if="btnEnableList.indexOf('3')>-1">导出</a-button>
                  </span>
                </a-col>
              </a-row>
            </a-form>
          </div>
          <section ref="print" id="reportPrint">
            <a-table
              bordered
              ref="table"
              size="middle"
              rowKey="rowIndex"
              :columns="columns"
              :dataSource="dataSource"
              :pagination="false"
              :scroll="scroll"
              :loading="loading"
              @change="handleTableChange">
            </a-table>
            <a-row :gutter="24" style="margin-top: 8px; text-align: right">
              <a-col :md="24" :sm="24">
                <a-pagination
                  @change="paginationChange"
                  @showSizeChange="paginationShowSizeChange"
                  size="small"
                  show-size-changer
                  show-quick-jumper
                  :current="ipagination.current"
                  :page-size="ipagination.pageSize"
                  :page-size-options="ipagination.pageSizeOptions"
                  :total="ipagination.total"
                  :show-total="(total) => `共 ${total} 条`">
                  <template slot="buildOptionText" slot-scope="props">
                    <span>{{ props.value }}条/页</span>
                  </template>
                </a-pagination>
              </a-col>
            </a-row>
          </section>
        </template>
        <!-- 打印模式（内嵌） -->
        <template v-if="printMode">
          <div class="print-header" style="display:flex; justify-content:space-between; align-items:center; padding:8px 16px; background:#fff; border-bottom:1px solid #e8e8e8; margin-bottom:12px;">
            <span style="font-size:16px; font-weight:500;">{{ printTitle }}</span>
            <a-button icon="close" @click="printMode = false">关闭</a-button>
          </div>
          <ReportPrint
            :visible="true"
            :tableData="dataSource"
            :queryParam="queryParam"
            billType="SALE_RATIO"
            billTypeName="销售占比"
            :buildData="buildPrintData"
            :embedded="true"
            @designer-change="onDesignerChange"
          />
        </template>
      </a-card>
    </a-col>
  </a-row>
</template>
<script>
import { getList } from '@/api/plugin/saleRatioStatistics'
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import { getAction } from '@/api/manage'
import { getAllOrganizationTreeByUser } from '@/api/api'
import ReportPrint from '@/views/plugin/print-template/ReportPrint.vue'
import StoreTenantSelect from '@/components/StoreTenantSelect'
import { buildPrintData } from './saleRatioConfig'
import moment from 'moment'

export default {
  name: "SaleRatioStatisticsList",
  mixins: [JeecgListMixin],
    components: {
      ReportPrint,
      StoreTenantSelect
    },
  data() {
    return {
      urlPath: '/plugin/saleRatioStatistics',
      labelCol: { span: 6 },
      wrapperCol: { span: 17, offset: 1 },
      queryParam: {
        dateRange: [moment().subtract(3, 'months'), moment()],
        categoryId: undefined,
        organizationId: undefined,
        beginTime: '',
        endTime: ''
      },
      ipagination: {
        current: 1,
        pageSize: 11,
        pageSizeOptions: ['10', '20', '30', '50', '100'],
        total: 0
      },
      categoryTree: [],
      orgaTree: [],
      pageName: 'saleRatioStatisticsList',
      defColumns: [
        { title: '序号', dataIndex: 'rowIndex', width: 60, align: 'center',
          customRender: function(t, r, index) { return t !== '合计' ? (parseInt(index) + 1) : t } },
        { title: '商品名称', dataIndex: 'mName', width: 160, ellipsis: true },
        { title: '类别名称', dataIndex: 'categoryName', width: 120, ellipsis: true },
        { title: '销售数量', dataIndex: 'allNum', width: 100, align: 'right' },
        { title: '销售金额', dataIndex: 'allPrice', width: 120, align: 'right',
          customRender: function(t) { return t != null ? '￥' + parseFloat(t).toFixed(2) : '￥0.00' } },
        { title: '销售占比', dataIndex: 'ratio', width: 100, align: 'right' }
      ],
      url: {
        list: '/api/plugin/sale-ratio-statistics/saleRatioStatistics/getList'
      },
      printMode: false,
      printTitle: '销售占比-打印预览'
    }
  },
  created() {
    this.columns = this.defColumns
    this.loadCategoryTree()
    this.initOrga()
  },
  methods: {
    buildPrintData,
    handleStoreTenantChange() {
      this.searchQuery()
    },
    handlePrint() {
      if (!this.dataSource || this.dataSource.length === 0) {
        this.$message.warning('暂无数据可打印')
        return
      }
      this.printTitle = '销售占比-打印预览'
      this.printMode = true
    },
    onDesignerChange(visible) {
      this.printTitle = visible ? '销售占比-报表设计' : '销售占比-打印预览'
    },
    loadCategoryTree() {
      getAction('/materialCategory/getMaterialCategoryTree', { id: '' }).then(res => {
        this.categoryTree = res || []
      }).catch(err => {
        console.error('加载类别失败', err)
      })
    },
    initOrga() {
      getAllOrganizationTreeByUser({}).then((res) => {
        this.orgaTree = res || []
      })
    },
    onDateChange(dates, dateStrings) {
      this.queryParam.beginTime = dateStrings[0]
      this.queryParam.endTime = dateStrings[1]
    },
    searchQuery() {
      this.ipagination.current = 1
      this.loadData()
    },
    searchReset() {
      this.queryParam = {
        dateRange: [moment().subtract(3, 'months'), moment()],
        categoryId: undefined,
        organizationId: undefined,
        beginTime: '',
        endTime: ''
      }
      this.ipagination.current = 1
      this.loadData()
    },
    loadData() {
      const dateRange = this.queryParam.dateRange || []
      const params = {
        beginTime: dateRange[0] ? dateRange[0].format('YYYY-MM-DD') : undefined,
        endTime: dateRange[1] ? dateRange[1].format('YYYY-MM-DD') : undefined,
        categoryId: this.queryParam.categoryId,
        organizationId: this.queryParam.organizationId || undefined,
        currentPage: this.ipagination.current,
        pageSize: this.ipagination.pageSize - 1
      }
      this.loading = true
      getList(params).then(res => {
        this.loading = false
        if (res && res.code === 200 && res.data) {
          const rows = res.data.rows || []
          rows.forEach((row, i) => {
            row.rowIndex = (this.ipagination.current - 1) * (this.ipagination.pageSize - 1) + i + 1
          })
          this.dataSource = rows
          this.ipagination.total = res.data.total || 0
          this.tableAddTotalRow(this.columns, this.dataSource)
        } else {
          this.dataSource = []
          this.ipagination.total = 0
        }
      }).catch(err => {
        this.loading = false
        this.$message.error('查询失败: ' + (err.message || '未知错误'))
        console.error(err)
      })
    },
    tableAddTotalRow(columns, dataSource) {
      if (dataSource.length > 0) {
        let numKey = 'rowIndex'
        let totalRow = { [numKey]: '合计' }
        let parseCols = 'allNum,allPrice,'
        columns.forEach(column => {
          let { key, dataIndex } = column
          if (![key, dataIndex].includes(numKey)) {
            let total = 0
            let hasSum = false
            dataSource.forEach(data => {
              if (parseCols.indexOf(dataIndex + ',') > -1) {
                hasSum = true
                if (data[dataIndex]) {
                  total += Number.parseFloat(data[dataIndex])
                }
              }
            })
            if (hasSum) {
              totalRow[dataIndex] = total.toFixed(2)
            } else {
              totalRow[dataIndex] = ''
            }
          }
        })
        dataSource.push(totalRow)
        let size = Math.ceil(this.ipagination.total / (this.ipagination.pageSize - 1))
        this.ipagination.total = this.ipagination.total + size
      }
    },
    paginationChange(page, pageSize) {
      this.ipagination.current = page
      this.ipagination.pageSize = pageSize
      this.loadData()
    },
    paginationShowSizeChange(current, size) {
      this.ipagination.current = 1
      this.ipagination.pageSize = size
      this.loadData()
    },
    handleTableChange(pagination, filters, sorter) {
      // 表格变化处理
    },
    exportExcel() {
      const list = []
      const head = '商品名称,类别名称,销售数量,销售金额,销售占比'
      const exportData = this.dataSource.filter(item => item.rowIndex !== '合计')
      for (let i = 0; i < exportData.length; i++) {
        const ds = exportData[i]
        list.push([
          ds.mName || '',
          ds.categoryName || '',
          ds.allNum || 0,
          ds.allPrice || 0,
          ds.ratio || ''
        ])
      }
      // 添加合计行
      let totalItem = ['-', '-', 0, 0, '-']
      for (let i = 0; i < exportData.length; i++) {
        const ds = exportData[i]
        totalItem[2] += Number.parseFloat(ds.allNum || 0)
        totalItem[3] += Number.parseFloat(ds.allPrice || 0)
      }
      totalItem[2] = totalItem[2].toFixed(2)
      totalItem[3] = totalItem[3].toFixed(2)
      list.push(totalItem)
      // 查询条件
      let tip = '查询条件'
      if (this.queryParam.beginTime && this.queryParam.endTime) {
        tip += ', 日期=' + this.queryParam.beginTime + '~' + this.queryParam.endTime
      }
      if (this.queryParam.categoryId) {
        tip += ', 类别ID=' + this.queryParam.categoryId
      }
      this.handleExportXlsPost('销售占比', '销售占比', head, tip, list)
    }
  }
}
</script>
<style scoped>
</style>